import { BodyLarge } from '../../common/body';
import { H4 } from '../../common/headline';
import { OurAttitudeToFoodImages } from './OurAttitudeToFoodImages';

export const OurAttitudeToFood = (): JSX.Element => (
  <section className="bg-grey-400 md:px-[40px] lg:px-[60px]">
    <div className="flex flex-col items-center md:container md:m-auto">
      <div className="mx-3 mt-16 text-blue md:hidden">
        <H4>
          At Second Nature we encourage a healthy relationship with food; one
          where you{"'"}ll never have to count what you eat or feel guilty for
          enjoying food. Food is a part of life, celebrations, and experiences.
        </H4>
      </div>
      <div className="mt-[104px] hidden max-w-[871px] text-center text-blue md:block">
        <BodyLarge>
          At Second Nature we encourage a healthy relationship with food; one
          where you{"'"}ll never have to count what you eat or feel guilty for
          enjoying food. Food is a part of life, celebrations, and experiences.
        </BodyLarge>
      </div>
      <OurAttitudeToFoodImages />
    </div>
  </section>
);
